import { ColDef } from 'ag-grid-community';
import { DefaultCellTooltip } from 'components/grids/tooltip/DefaultCellTooltip';
import { addCommasFor } from 'components/vars/common/FormatNumber';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useOPaymentDetailAdColDefs = () => {
  const { t } = useTranslation();
  const defaultColDef1 = useMemo((): ColDef => {
    return {
      sortable: true, // 요구사항8번 sortable: true로 변경하면 됨
      resizable: true,
      cellStyle: { textAlign: 'center' },
      tooltipComponent: DefaultCellTooltip,
    };
  }, []);

  // 요구사항8번 # 제거 Document=> 전표 번호로 수정
  const colDefs1: any = [
    {
      // headerName: t('com.label.00628', '__Document'),
      // headerTooltip: t('com.label.00628', '__Document'),
      headerName: t('com.label.00122', '__Document No.'),
      headerTooltip: t('com.label.00122', '__Document No.'),
      field: 'slipNo',
      tooltipField: 'slipNo',
      width: 120,
    },
    {
      // 영문은 동일하게 Document Date임
      // headerName: t('com.label.00629', '__Document Date'),
      // headerTooltip: t('com.label.00629', '__Document Date'),
      headerName: t('com.label.00123', '__Document Date'),
      headerTooltip: t('com.label.00123', '__Document Date'),
      field: 'prfDt',
      tooltipField: 'prfDt',
      width: 120,
    },
    {
      headerName: t('com.label.00631', '__Amount'),
      headerTooltip: t('com.label.00631', '__Amount'),
      field: 'payAmt',
      tooltipField: 'payAmt',
      cellStyle: { textAlign: 'right' },
      valueFormatter: (params) => addCommasFor(params.value),
      width: 120,
    },
    {
      headerName: t('com.label.00632', '__Invoice No.'),
      headerTooltip: t('com.label.00632', '__Invoice No.'),
      field: 'invcNo',
      tooltipField: 'invcNo',
      flex: 1,
    },
    {
      headerName: t('com.label.00633', '__Reference No.'),
      headerTooltip: t('com.label.00633', '__Reference No.'),
      field: 'rfrnNo',
      tooltipField: 'rfrnNo',
      minWidth: 140,
    },
    {
      headerName: t('com.label.00647', '__Check No.'),
      headerTooltip: t('com.label.00647', '__Check No.'),
      field: 'chckNo',
      tooltipField: 'chckNo',
      minWidth: 130,
    },
    /*Department in charge*/
    {
      // headerName: t('com.label.00634', '__Department'),
      // headerTooltip: t('com.label.00634', '__Department'),
      headerName: t('com.label.00125', '__Department in charge'),
      headerTooltip: t('com.label.00125', '__Department in charge'),
      field: 'mgrDeptNm',
      tooltipField: 'mgrDeptNm',
      flex: 1,
    },
    {
      headerName: t('com.label.00635', '__Purchase Order'),
      headerTooltip: t('com.label.00635', '__Purchase Order'),
      field: 'purcOrd',
      tooltipField: 'purcOrd',
      width: 120,
    },
  ];

  return { defaultColDef1, colDefs1 };
};
